import SHA256 from 'crypto-js/sha256';
import { useState, ChangeEvent, useEffect } from 'react';
import { AccessTabProps } from '..';
import { useLandingTabActions } from '../../../hosting/CustomizationSection/tabs/LandingTab/hooks';

const useWebinarAccess = ({ access, webinar }: AccessTabProps) => {
  const { nameEmail, passwordHash, password } = access;

  const [isPassword, setIsPassword] = useState(!!passwordHash);

  const [updateLandingParams] = useLandingTabActions(webinar, false);

  const updatePassword = (password: string | null) => {
    updateLandingParams({
      key: 'access',
      params: {
        nameEmail,
        password,
        granted: !password,
        passwordHash: password ? `${SHA256(password)}` : null
      }
    });
  };

  const onNameEmailSelect = (e: ChangeEvent<HTMLInputElement>) => {
    const isEnabled = e.target.checked;

    updateLandingParams({
      key: 'access',
      params: {
        ...access,
        granted: !isEnabled && !access.password,
        nameEmail: isEnabled
      }
    });
  };

  const onPasswordSelect = (e: ChangeEvent<HTMLInputElement>) => {
    setIsPassword(e.target.checked);

    const isDisabled = !e.target.checked;

    if (isDisabled && passwordHash) {
      updatePassword(null);
    }
  };

  useEffect(() => {
    if (!passwordHash) {
      setIsPassword(false);
    }
  }, [passwordHash]);

  return [nameEmail, password, isPassword, updatePassword, onNameEmailSelect, onPasswordSelect] as const;
};

export default useWebinarAccess;
